@if (hasRenderableData()) {
  @if (graph().series.length > 1 || showFirstObservedLegend()) {
    <div class="chart-legend" role="group" [attr.aria-label]="graph().title + ' series'">
      @for (series of coloredSeries(); track $index) {
        @if (graph().series.length > 1) {
        <button [attr.aria-pressed]="selectedSeries().has($index)"
          [class.chart-legend__entry--dimmed]="selectedSeries().size > 0 && !selectedSeries().has($index)"
          [title]="series.name" (click)="toggleSeries($index)" type="button" class="chart-legend__entry">
          <span [style.background-color]="series.color" class="chart-legend__swatch" aria-hidden="true"></span>
          <span>{{ series.name }}</span>
        </button>
        } @else {
          <span class="chart-legend__entry chart-legend__entry--label">
            <span [style.background-color]="series.color" class="chart-legend__swatch" aria-hidden="true"></span>
            <span>{{ series.name }}</span>
          </span>
        }
      }
      @if (showFirstObservedLegend()) {
        <span class="chart-legend__entry chart-legend__entry--label">
          <span class="chart-legend__swatch chart-legend__swatch--reference" aria-hidden="true"></span>
          <span>First observed</span>
        </span>
      }
      @if (selectedSeries().size > 0) {
        <button (click)="clearSeriesSelection()" type="button" class="iopoc-button small primary chart-legend__reset">
          Reset chart
        </button>
      }
    </div>
  }
  <div class="chart-container" [style.height]="height()">
    <canvas
      [type]="chartViewModel().type"
      [data]="chartViewModel().data"
      [options]="chartViewModel().options"
      [plugins]="chartPlugins"
      [attr.tabindex]="chartViewModel().type === 'line' ? 0 : null"
      [attr.aria-label]="graph().title + (chartViewModel().type === 'line' ? '. Use Left and Right arrows to inspect recorded values, Home and End to jump, and Escape to clear.' : '')"
      (keydown)="onChartKeydown($event)"
      (blur)="clearScrub()"
      baseChart>
    </canvas>
    @if (tooltip(); as currentTooltip) {
      <div #chartTooltip
        [style.left.px]="tooltipPosition().left" [style.top.px]="tooltipPosition().top"
        class="chart-tooltip" role="tooltip">
        @if (currentTooltip.title) {
          <div class="chart-tooltip__title">{{ currentTooltip.title }}</div>
        }
        @for (entry of currentTooltip.entries; track $index) {
          <div class="chart-tooltip__entry">
            <span [style.background-color]="entry.color" class="chart-tooltip__swatch" aria-hidden="true"></span>
            <div class="chart-tooltip__reading">
              @if (currentTooltip.showNames) {
                <div><strong>{{ entry.name }}</strong>: {{ entry.value }}</div>
              } @else {
                <div><span class="visually-hidden">{{ entry.name }}: </span>{{ entry.value }}</div>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
  @if (firstObservedLabel(); as label) {
    <p class="chart-reference">{{ label }}</p>
  }
  <span class="chart-announcement" role="status" aria-live="polite">{{ scrubAnnouncement() }}</span>
}
